import React, { Component } from 'react'


export default class Header extends Component {
  render() {
    return (
      <div className="Header">
        <img src="https://i-love-png.com/images/blog-logo_14551.png"/>
        <div>TODO</div>
      </div>
    )
  }
}

